var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.setting !== null ? _c('footer', {
    staticClass: "footer-wrap clearfix"
  }, [_c('div', {
    staticClass: "max-width-wrap clearfix"
  }, [_c('div', {
    staticClass: "tablet-wrap clearfix"
  }, [_c('div', {
    staticClass: "column-one"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": _vm.homeUrl
    }
  }, [_vm.siteInfo.site_logo_dark ? [_c('img', {
    attrs: {
      "src": _vm.siteInfo.site_logo_dark,
      "alt": _vm.companyName
    }
  })] : [_c('strong', {
    staticClass: "site-name-fallback"
  }, [_vm._v(" " + _vm._s(_vm.companyName) + " ")])]], 2), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "copyright-wrap-desktop"
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " " + _vm._s(_vm.companyName) + ". All rights reserved.")])])]), _vm.hasNavigationMenu ? _c('div', {
    staticClass: "column-two"
  }, [_c('h2', [_vm._v(_vm._s(_vm.navigationMenuTitle))]), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l(_vm.getFooterNavigationMenu.items, function (item) {
    return _c('li', {
      key: item.ID
    }, [_c('a', {
      staticClass: "page-hyper-link",
      attrs: {
        "href": item.url,
        "target": item.target || '_self',
        "title": item.attr_title
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 0)]) : _vm._e(), _vm.hasCommunityMenu ? _c('div', {
    staticClass: "column-three"
  }, [_c('h2', [_vm._v(_vm._s(_vm.communityMenuTitle))]), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l(_vm.getFooterCommunityMenu.items, function (item) {
    return _c('li', {
      key: item.ID
    }, [_c('a', {
      staticClass: "page-hyper-link",
      attrs: {
        "href": item.url,
        "target": item.target || '_self',
        "title": item.attr_title
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 0)]) : _vm._e()]), _c('div', {
    staticClass: "column-four clearfix"
  }, [_c('h2', [_vm._v("Find Us On Social Media")]), _vm._l(_vm.socialMediaLinks, function (social) {
    return _c('a', {
      key: social.name,
      staticClass: "social-link",
      attrs: {
        "href": social.url,
        "aria-label": social.name
      }
    }, [_c('img', {
      attrs: {
        "src": social.icon,
        "alt": social.name
      }
    })]);
  })], 2), _c('div', {
    staticClass: "copyright-wrap-mobile"
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " " + _vm._s(_vm.companyName) + ". All rights reserved.")])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "address-wrap"
  }, [_c('img', {
    staticClass: "pin-icon",
    attrs: {
      "src": "/assets/images/pin-icon-v1.svg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "address"
  }, [_c('p', [_vm._v("Abu Dhabi, UAE")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "email-wrap"
  }, [_c('img', {
    staticClass: "mail-icon",
    attrs: {
      "src": "/assets/images/mail-icon-v1.svg",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:support@mywhoosh.com"
    }
  }, [_vm._v("Support@mywhoosh.com")])]);
}]

export { render, staticRenderFns }